// extracted by mini-css-extract-plugin
export default {"item":"CardPlain-module--item--07980","link":"CardPlain-module--link--d7f2d"};